import React, { useEffect } from 'react'
import {
  IconButton,
  Dialog,
  Box,
  TextField,
  Button,
  DialogTitle,
  DialogActions,
  Stack,
  InputLabel,
  Typography
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import SnackBarUtils from '../../../utils/SnackBarUtils'

interface AddTextDialogProps {
  open: boolean
  setAddText: (add: boolean) => void
  desc: string
  setDesc: (cta: string) => void
  index: number
  images: any[]
  setImages: (imgs: any[]) => void
}

const MAX_DESC_LENGTH = 45

export const AddTextDialog = ({ open, setAddText, desc, setDesc, index, images, setImages }: AddTextDialogProps) => {
  const handleClose = () => {
    setAddText(false)
  }

  const handleSave = () => {
    const updatedImages = [...images]
    updatedImages[index] = { ...updatedImages[index], cta: desc !== '' ? desc : null }
    // Guardamos los cambios
    setImages(updatedImages)
    SnackBarUtils.success('Descripción guardada')
    handleClose()
  }

  useEffect(() => {
    setDesc(images[index]?.cta)
  }, [index])

  return (
    <Dialog
      fullWidth
      open={open}
      onClose={handleClose}
      PaperProps={{
        style: {
          overflowX: 'hidden',
          width: '100%'
        }
      }}
    >
      <DialogTitle>Agregar descripción</DialogTitle>
      <Box
        sx={{
          padding: '1rem'
        }}
      >
        <Stack sx={{ width: '100%' }} spacing={1}>
          <InputLabel
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%'
            }}
          >
            Texto
            <Typography variant="subtitle2">
              {desc?.length || 0}/{MAX_DESC_LENGTH}
            </Typography>
          </InputLabel>
          <TextField
            onChange={(e) => setDesc(e.target.value)}
            value={desc}
            variant="outlined"
            sx={{ width: '100%', marginBottom: '1rem' }}
            inputProps={{ maxLength: MAX_DESC_LENGTH }}
          />
        </Stack>
      </Box>
      <IconButton
        edge="end"
        onClick={handleClose}
        style={{
          position: 'absolute',
          top: '0',
          right: '0',
          paddingRight: '16px'
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogActions sx={{ padding: '0 1rem 1rem 1rem' }}>
        <Button variant="contained" color="error" onClick={handleClose} sx={{ width: '50%' }}>
          Cancelar
        </Button>
        <Button variant="contained" color="success" onClick={handleSave} sx={{ width: '50%' }} type="submit">
          Guardar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddTextDialog
